export enum Origen {
    offLine = 'offLine',
    onLine = 'online',
    excel = 'excel'
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/enum/origen.enum.ts